import http from '@/services/BackendService'

const BASE_PATH = '/floodReliefMission/admin'

export default {
    // Summary statistics
    getSummary() {
        return http.get(`${BASE_PATH}/summary`)
    },
    
    // Get all requests with pagination
    getRequests(page = 1) {
        return http.get(`${BASE_PATH}/requests`, { params: { page } })
    },
    
    // Search requests with filters
    searchRequests(params = {}) {
        return http.get(`${BASE_PATH}/requests/search`, { params })
    },
    
    // Get single request detail
    getRequestDetail(id) {
        return http.get(`${BASE_PATH}/requests/${id}`)
    },
    
    // Update request (status, admin_notes, approved_amount, cuci_paid_slips) - ใช้ FormData + _method PUT
    updateRequest(id, payload) {
        let data = new FormData()
        data.append('status', payload.status)
        if (payload.admin_notes !== null && payload.admin_notes !== undefined) {
            data.append('admin_notes', payload.admin_notes)
        }
        if (payload.approved_amount !== null && payload.approved_amount !== undefined) {
            data.append('approved_amount', payload.approved_amount)
        }
        // Append cuci_paid_slips files if provided
        if (payload.cuci_paid_slips && payload.cuci_paid_slips.length > 0) {
            payload.cuci_paid_slips.forEach(file => {
                data.append('cuci_paid_slips[]', file)
            })
        }
        data.append('_method', 'PUT')
        return http.post(`${BASE_PATH}/requests/${id}`, data)
    },
    
    // Send email notification manually
    sendEmail(id) {
        return http.post(`${BASE_PATH}/requests/${id}/sendEmail`)
    },

    // Delete CUCI paid slip
    deleteCuciPaidSlip(requestId, fileId) {
        return http.delete(`${BASE_PATH}/requests/${requestId}/cuciPaidSlip/${fileId}`)
    }
}
